import { isAddonLine } from './orderAddons';

// Kid name and photos live on a story line as properties: "Kid Name" and
// "Photo 1", "Photo 2", ... (see ShopifySchemaHelpers.mapManualItems).
const PHOTO_PROPERTY = /^Photo (\d+)$/;

const propertyValue = (line, name) => (
  (Array.isArray(line?.properties) ? line.properties : [])
    .find(prop => prop?.name === name)?.value
);

/**
 * Photos of a story line in their original order, shaped like the entries
 * PhotoUploader produces. Only uploaded photos (with a URL) are returned.
 */
export function getLinePhotos(line) {
  return (Array.isArray(line?.properties) ? line.properties : [])
    .map(prop => ({ number: Number(PHOTO_PROPERTY.exec(prop?.name || '')?.[1]), url: prop?.value }))
    .filter(photo => photo.number > 0 && photo.url)
    .sort((a, b) => a.number - b.number)
    .map((photo, index) => ({
      id: `line-photo-${index}`,
      status: 'done',
      name: `Photo ${photo.number}`,
      url: photo.url
    }));
}

/** Copies photos with fresh ids so two story entries never share one. */
export function copyPhotos(photos, prefix) {
  return (photos || []).map((photo, index) => ({ ...photo, id: `${prefix}-photo-${index}` }));
}

/** Kid name and photos of a story line, ready to prefill an entry. */
export function getLineKid(line) {
  return {
    kidName: String(propertyValue(line, 'Kid Name') ?? '').trim(),
    photos: getLinePhotos(line)
  };
}

/**
 * Distinct kids on an order, in line order. Story lines that share a kid name
 * count once; the first photos found for that name are kept.
 */
export function getOrderKids(order) {
  const kids = [];
  (Array.isArray(order?.line_items) ? order.line_items : [])
    .filter(line => !isAddonLine(line))
    .forEach(line => {
      const { kidName, photos } = getLineKid(line);
      if (!kidName) return;
      const existing = kids.find(kid => kid.name === kidName);
      if (existing) {
        if (existing.photos.length === 0 && photos.length > 0) existing.photos = photos;
        return;
      }
      kids.push({ name: kidName, photos });
    });
  return kids;
}
